const COMPACT_ATTENDANCE_ROLES = new Set([
  'mediador cop',
  'mediador control social'
]);

function normalizeRoleName(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function usesCompactAttendanceCharacterization(role) {
  return COMPACT_ATTENDANCE_ROLES.has(normalizeRoleName(role));
}
